/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div
      className='auth-layout-container d-flex flex-column flex-lg-row flex-column-fluid position-relative overflow-hidden'
      style={{ minHeight: '100vh' }}
    >
      <style>{`
        .auth-layout-container {
          position: relative;
          background-color: #0b0e17;
          overflow: hidden;
          transition: background-color 0.3s ease;
        }

        html[data-bs-theme="light"] .auth-layout-container {
          background-color: #f4f6fa !important;
        }

        .geo-bg-triangle-1 {
          position: absolute;
          top: 0;
          left: 0;
          width: 55vw;
          height: 100vh;
          background: linear-gradient(135deg, rgba(36, 92, 146, 0.18) 0%, rgba(36, 92, 146, 0.02) 100%);
          clip-path: polygon(0 0, 100% 0, 40% 100%, 0 100%);
          pointer-events: none;
          z-index: 1;
        }

        .geo-bg-triangle-2 {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 50vw;
          height: 80vh;
          background: linear-gradient(315deg, rgba(237, 50, 55, 0.1) 0%, rgba(36, 92, 146, 0.02) 100%);
          clip-path: polygon(100% 100%, 0 100%, 100% 20%);
          pointer-events: none;
          z-index: 1;
        }

        html[data-bs-theme="light"] .geo-bg-triangle-1 {
          background: linear-gradient(135deg, rgba(0, 90, 170, 0.08) 0%, rgba(14, 165, 233, 0.01) 100%) !important;
        }
        html[data-bs-theme="light"] .geo-bg-triangle-2 {
          background: linear-gradient(315deg, rgba(99, 102, 241, 0.06) 0%, rgba(0, 90, 170, 0.01) 100%) !important;
        }

        .svg-geo-element {
          position: absolute;
          pointer-events: none;
          z-index: 1;
        }
        .svg-triangle-top-left {
          top: 40px;
          left: 60px;
          animation: floatGeo1 9s ease-in-out infinite alternate;
        }
        .svg-triangle-bottom-right {
          bottom: 60px;
          right: 80px;
          animation: floatGeo2 11s ease-in-out infinite alternate;
        }
        .svg-triangle-center {
          top: 45%;
          left: 42%;
          animation: floatGeo1 13s ease-in-out infinite alternate;
        }

        @keyframes floatGeo1 {
          0% { transform: translateY(0px) rotate(0deg); }
          100% { transform: translateY(-16px) rotate(6deg); }
        }
        @keyframes floatGeo2 {
          0% { transform: translateY(0px) rotate(0deg); }
          100% { transform: translateY(18px) rotate(-8deg); }
        }

        .corner-box-matrix-tl {
          position: absolute;
          top: 28px;
          left: 28px;
          display: grid;
          grid-template-columns: repeat(4, 14px);
          gap: 6px;
          pointer-events: none;
          z-index: 1;
        }
        .corner-box-matrix-br {
          position: absolute;
          bottom: 28px;
          right: 28px;
          display: grid;
          grid-template-columns: repeat(4, 14px);
          gap: 6px;
          pointer-events: none;
          z-index: 1;
        }

        .matrix-box {
          width: 14px;
          height: 14px;
          border: 1.5px solid rgba(56, 189, 248, 0.25);
          border-radius: 3px;
          background: rgba(56, 189, 248, 0.05);
          transition: all 0.3s ease;
        }
        .matrix-box.filled {
          background: rgba(56, 189, 248, 0.3);
          border-color: rgba(56, 189, 248, 0.6);
        }
        .matrix-box.accent {
          background: rgba(0, 90, 170, 0.4);
          border-color: rgba(0, 90, 170, 0.8);
        }

        html[data-bs-theme="light"] .matrix-box {
          border-color: rgba(0, 90, 170, 0.3) !important;
          background: rgba(0, 90, 170, 0.05) !important;
        }
        html[data-bs-theme="light"] .matrix-box.filled {
          background: rgba(0, 90, 170, 0.2) !important;
        }

        .floating-wireframe-box {
          position: absolute;
          pointer-events: none;
          z-index: 1;
          border: 1.5px solid rgba(56, 189, 248, 0.3);
          border-radius: 8px;
          background: rgba(14, 165, 233, 0.04);
          transform: rotate(45deg);
        }
        .wire-box-1 {
          top: 12%;
          left: 18%;
          width: 48px;
          height: 48px;
          animation: spinBox 20s linear infinite;
        }
        .wire-box-2 {
          bottom: 18%;
          left: 8%;
          width: 64px;
          height: 64px;
          border-color: rgba(99, 102, 241, 0.35);
          animation: spinBoxRev 25s linear infinite;
        }
        .wire-box-3 {
          top: 20%;
          right: 12%;
          width: 56px;
          height: 56px;
          border-color: rgba(245, 158, 11, 0.35);
          animation: spinBox 22s linear infinite;
        }

        @keyframes spinBox {
          0% { transform: rotate(45deg); }
          100% { transform: rotate(405deg); }
        }
        @keyframes spinBoxRev {
          0% { transform: rotate(45deg); }
          100% { transform: rotate(-315deg); }
        }

        .corner-bracket {
          position: absolute;
          width: 32px;
          height: 32px;
          pointer-events: none;
          z-index: 1;
          border-color: rgba(56, 189, 248, 0.4);
          border-style: solid;
        }
        .bracket-tl {
          top: 16px;
          left: 16px;
          border-width: 2px 0 0 2px;
        }
        .bracket-tr {
          top: 16px;
          right: 16px;
          border-width: 2px 2px 0 0;
        }
        .bracket-bl {
          bottom: 16px;
          left: 16px;
          border-width: 0 0 2px 2px;
        }
        .bracket-br {
          bottom: 16px;
          right: 16px;
          border-width: 0 2px 2px 0;
        }

        .auth-layout-left,
        .auth-layout-right {
          position: relative;
          z-index: 2;
          background-color: transparent !important;
        }

        /* --- GLOWING ANIMATED BLOBS --- */
        .bg-blob {
          position: absolute;
          filter: blur(100px);
          z-index: 0;
          opacity: 0.5;
          border-radius: 50%;
          animation: floatBlob 25s infinite alternate ease-in-out;
          pointer-events: none;
          transform: translateZ(0);
          will-change: transform;
        }

        .blob-1 {
          top: -10%;
          left: -10%;
          width: 50vw;
          height: 50vw;
          max-width: 600px;
          max-height: 600px;
          background: rgba(36, 92, 146, 0.5);
          animation-delay: 0s;
        }

        .blob-2 {
          bottom: -20%;
          right: -10%;
          width: 60vw;
          height: 60vw;
          max-width: 700px;
          max-height: 700px;
          background: rgba(237, 50, 55, 0.25);
          animation-duration: 30s;
          animation-delay: -5s;
        }

        .blob-3 {
          top: 30%;
          left: 50%;
          width: 40vw;
          height: 40vw;
          max-width: 500px;
          max-height: 500px;
          background: rgba(36, 92, 146, 0.2);
          animation-duration: 35s;
          animation-delay: -12s;
        }
        
        .blob-4 {
          bottom: 10%;
          left: 5%;
          width: 35vw;
          height: 35vw;
          max-width: 450px;
          max-height: 450px;
          background: rgba(237, 50, 55, 0.15);
          animation-duration: 28s;
          animation-delay: -8s;
        }

        html[data-bs-theme="light"] .bg-blob {
          opacity: 0.3;
        }
        html[data-bs-theme="light"] .blob-1 { background: rgba(36, 92, 146, 0.3); }
        html[data-bs-theme="light"] .blob-2 { background: rgba(237, 50, 55, 0.15); }
        html[data-bs-theme="light"] .blob-3 { background: rgba(36, 92, 146, 0.15); }
        html[data-bs-theme="light"] .blob-4 { background: rgba(237, 50, 55, 0.1); }

        @keyframes floatBlob {
          0% { transform: translate3d(0, 0, 0); }
          50% { transform: translate3d(3vw, -4vh, 0); }
          100% { transform: translate3d(-2vw, 3vh, 0); }
        }

        @media (max-width: 991.98px) {
          .corner-box-matrix-tl,
          .corner-box-matrix-br,
          .corner-bracket,
          .floating-wireframe-box {
            display: none !important;
          }
          .auth-layout-container {
            justify-content: center;
            padding: 24px 16px !important;
          }
          .auth-layout-left {
            order: 1 !important;
            width: 100% !important;
            padding: 0 !important;
            margin-bottom: 24px !important;
            flex: none !important;
          }
          .auth-layout-right {
            display: none !important;
          }
          .auth-layout-left > div {
            width: 100% !important;
          }
          .w-lg-500px {
            width: 100% !important;
            max-width: 460px !important;
            padding: 8px !important;
            margin: 0 auto;
          }
        }
        
        @media (max-width: 575.98px) {
          .auth-layout-container {
            padding: 16px 8px !important;
          }
          .auth-layout-right {
            height: 150px !important;
            min-height: 150px !important;
          }
          .w-lg-500px {
            padding: 0 !important;
          }
        }
      `}</style>

      <div className='geo-bg-triangle-1'></div>
      <div className='geo-bg-triangle-2'></div>

      {/* GLOWING ANIMATED BLOBS */}
      <div className='bg-blob blob-1'></div>
      <div className='bg-blob blob-2'></div>
      <div className='bg-blob blob-3'></div>
      <div className='bg-blob blob-4'></div>

      <svg className='svg-geo-element svg-triangle-top-left' width='140' height='140' viewBox='0 0 100 100' fill='none'>
        <polygon points='50,10 90,90 10,90' stroke='rgba(56, 189, 248, 0.35)' strokeWidth='2' fill='rgba(56, 189, 248, 0.03)' />
        <polygon points='50,25 78,80 22,80' stroke='rgba(0, 90, 170, 0.3)' strokeWidth='1.5' fill='none' />
      </svg>

      <svg className='svg-geo-element svg-triangle-bottom-right' width='160' height='160' viewBox='0 0 100 100' fill='none'>
        <polygon points='10,10 90,30 50,90' stroke='rgba(99, 102, 241, 0.35)' strokeWidth='2' fill='rgba(99, 102, 241, 0.04)' />
      </svg>

      <svg className='svg-geo-element svg-triangle-center d-none d-lg-block' width='90' height='90' viewBox='0 0 100 100' fill='none'>
        <polygon points='50,5 95,95 5,95' stroke='rgba(245, 158, 11, 0.3)' strokeWidth='1.5' fill='none' />
      </svg>

      <div className='corner-box-matrix-tl d-none d-md-grid'>
        <div className='matrix-box filled'></div>
        <div className='matrix-box'></div>
        <div className='matrix-box accent'></div>
        <div className='matrix-box'></div>
        <div className='matrix-box'></div>
        <div className='matrix-box filled'></div>
        <div className='matrix-box'></div>
        <div className='matrix-box accent'></div>
        <div className='matrix-box accent'></div>
        <div className='matrix-box'></div>
        <div className='matrix-box filled'></div>
        <div className='matrix-box'></div>
      </div>

      <div className='corner-box-matrix-br d-none d-md-grid'>
        <div className='matrix-box'></div>
        <div className='matrix-box accent'></div>
        <div className='matrix-box filled'></div>
        <div className='matrix-box'></div>
        <div className='matrix-box filled'></div>
        <div className='matrix-box'></div>
        <div className='matrix-box accent'></div>
        <div className='matrix-box filled'></div>
        <div className='matrix-box'></div>
        <div className='matrix-box filled'></div>
        <div className='matrix-box'></div>
        <div className='matrix-box accent'></div>
      </div>

      <div className='floating-wireframe-box wire-box-1 d-none d-lg-block'></div>
      <div className='floating-wireframe-box wire-box-2 d-none d-lg-block'></div>
      <div className='floating-wireframe-box wire-box-3 d-none d-lg-block'></div>

      <div className='corner-bracket bracket-tl d-none d-md-block'></div>
      <div className='corner-bracket bracket-tr d-none d-md-block'></div>
      <div className='corner-bracket bracket-bl d-none d-md-block'></div>
      <div className='corner-bracket bracket-br d-none d-md-block'></div>

      <div className='auth-layout-left d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          <div className='w-lg-500px p-10'>
            <Outlet />
          </div>
        </div>
        <div className='d-flex flex-center flex-wrap px-5'></div>
      </div>

      <div
        className='auth-layout-right d-flex flex-lg-row-fluid w-lg-50 order-1 order-lg-2'
        style={{
          backgroundImage: `url(${toAbsoluteUrl('/media/misc/carmain.svg')})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'right center',
        }}
      ></div>
    </div>
  )
}

export { AuthLayout }
